// Ported verbatim from the LeadMailer Design System (components/forms/Field.jsx).
import React from 'react'

export interface FieldProps {
  label?: React.ReactNode
  hint?: React.ReactNode
  error?: React.ReactNode
  htmlFor?: string
  children?: React.ReactNode
  style?: React.CSSProperties
}

export function Field({ label, hint, error, htmlFor, children, style }: FieldProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <label
          htmlFor={htmlFor}
          style={{
            fontSize: 'var(--text-sm)',
            fontWeight: 'var(--weight-medium)' as React.CSSProperties['fontWeight'],
            color: 'var(--text-primary)',
          }}
        >
          {label}
        </label>
      )}
      {children}
      {error ? (
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--danger-text)' }}>{error}</div>
      ) : hint ? (
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>{hint}</div>
      ) : null}
    </div>
  )
}

export function useFieldStyle(
  error?: React.ReactNode,
): [React.CSSProperties, { onFocus: () => void; onBlur: () => void }] {
  const [focus, setFocus] = React.useState(false)
  return [
    {
      width: '100%',
      boxSizing: 'border-box',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      color: 'var(--text-primary)',
      background: 'var(--surface-card)',
      border: `1px solid ${
        error ? 'var(--danger)' : focus ? 'var(--border-focus)' : 'var(--border-default)'
      }`,
      borderRadius: 'var(--radius-sm)',
      outline: 'none',
      boxShadow: focus ? 'var(--ring-focus)' : 'var(--shadow-xs)',
      transition:
        'border-color var(--dur-fast) var(--ease-out),box-shadow var(--dur-fast) var(--ease-out)',
    },
    { onFocus: () => setFocus(true), onBlur: () => setFocus(false) },
  ]
}
